import { render } from "./KnowledgebaseUpload.vue?vue&type=template&id=7cb67860&ts=true"
import script from "./KnowledgebaseUpload.vue?vue&type=script&lang=ts"
export * from "./KnowledgebaseUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__